import { XIcon } from '../../../components/shared/icons';

interface Props {
    label: string;
    onRemove: () => void;
}

export function FilterLabel({ label, onRemove }: Props) {
    return (
        <button
            type='button'
            aria-label={`Remove ${label} filter`}
            className='bg-theme-500 ps-2 pe-1 py-0.5 round:rounded-md border border-theme-400 hover:border-red-500 group slow-effect-transition shrink-0 flex items-center gap-1 whitespace-nowrap capitalize'
            onClick={onRemove}
        >
            <span>{label}</span>
            <span aria-hidden className='group-hover:text-red-500 slow-effect-transition'>
                <XIcon size={18} />
            </span>
        </button>
    );
}
